/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolcardremoving2Inputs */

const en_toolcardremoving2 = /** @type {(inputs: Toolcardremoving2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`removing…`)
};

const pt_toolcardremoving2 = /** @type {(inputs: Toolcardremoving2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a remover…`)
};

/**
* | output |
* | --- |
* | "removing…" |
*
* @param {Toolcardremoving2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const toolcardremoving2 = /** @type {((inputs?: Toolcardremoving2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolcardremoving2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toolcardremoving2(inputs)
	return pt_toolcardremoving2(inputs)
});
export { toolcardremoving2 as "toolCardRemoving" }